// extracted by mini-css-extract-plugin
export default {"placeholder":"styles_placeholder__MpdOF","image":"styles_image__9pDZy","error":"styles_error__d18SN"};